var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('el-checkbox-group',{model:{value:(_vm.ids),callback:function ($$v) {_vm.ids=$$v},expression:"ids"}},_vm._l((_vm.list),function(item){return _c('el-checkbox',{key:item.serviceId,attrs:{"label":item.serviceId}},[_vm._v(_vm._s(item.serviceName))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }